import { styled } from '@material-ui/styles';
import { Box } from '@material-ui/core';

export const Line = styled(Box)({
  width: '40px',
  height: '2px',
  borderRadius: '2px',
  background: '#000000',
});
